var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":"Age","placeholder":_vm.placeholder,"items":_vm.categories,"item-text":"age","item-value":"age","clearable":true,"loading":_vm.loading,"disabled":_vm.isDisabled,"hide-no-data":"hide-no-data"},model:{value:(_vm.categoryAge),callback:function ($$v) {_vm.categoryAge=$$v},expression:"categoryAge"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2306eac2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CategoryAgeSelector.vue
// module id = null
// module chunks = 